<template>
  <div class="guarantor-new">
    <Steps :current="curStep">
      <Step title="入会须知" content="仔细阅读《入会须知》"></Step>
      <Step title="填写信息" content="填写入会申请信息并按要求上传附件"></Step>
      <Step title="等待审核" content="等待协会审核"></Step>
    </Steps>
    <div class="padding-top-20"></div>
    <div class="guarantor-contract" v-if="curStep===0">
      <Tabs value="contract">
        <TabPane label="入会须知" name="contract">
          <div class="guarantor-contract-content">
            <div class="container">
              <h1>河南省工程担保行业协会入会须知</h1>
              <p class="article title">
                一、申请加入本会的单位会员，须同时具备下列条件：
              </p>
              <p class="article">
                凡在河南省行政区域内从事工程担保业务的银行、保险公司、专业工程担保公司，以及与建筑行业、工程管理、工程担保发展密切相关的科研院所、大专院校等企事业单位，依规守法经营，拥护本会章程，积极参加党建活动，均可自愿申请入会。
              </p>
              <p class="article title">
                二、入会办理流程：
              </p>
              <p class="article">
                1.登录河南省工程保证信息网首页，进入入会申请入口完成账号注册；
              </p>
              <p class="article">
                2.按网站页面提示在线填报信息，并上传以下资料：
              </p>
              <p class="article">
                ○ 入会申请书
              </p>
              <p class="article">
                ○ 营业执照
              </p>
              <p class="article">
                ○ 法人身份证复印件
              </p>
              <p class="article">
                ○ 法人代表授权委托书
              </p>
              <p class="article">
                ○ 本单位公司章程
              </p>
              <p class="article">
                ○ 保证业务管理制度、业务流程资料
              </p>
              <p class="article">
                ○ 工程风险评价及风险管控制度文件
              </p>
              <p class="article">
                ○ 近期经审计的财务报表
              </p>
              <p class="article">
                ○ 行业自律公约
              </p>
              <p class="article">
                3.所有申报纸质资料加盖企业公章，邮寄至河南省工程担保行业协会用于核对存档；
              </p>
              <p class="article">
                4.联系协会工作人员，按照《工程保证保证人履约能力评价管理办法》进行履约能力评价；
              </p>
              <p class="article">
                5.上述材料审核通过后缴纳会费，由协会秘书处颁发会员证书。
              </p>
              <p class="article title">
                三、入会办理联系方式：
              </p>
              <p class="article">
                联 系 人：丁锐、刘丽
              </p>
              <p class="article">
                电  话：0371—69179969
              </p>
              <p class="article">
                地   址：兴业大厦2505房（郑州市金水区未来大道东、金水路北14号楼2505号）
              </p>
              <p class="article">&nbsp;</p>
              <p class="article"><strong>您点击下方的“同意并继续”按钮即视为您完全接受本合同，知悉并完全理解本协议的全部内容，本合同内容即对贵方产生法律效力。</strong></p>
              <p class="article">&nbsp;</p>
            </div>
          </div>
        </TabPane>
      </Tabs>
      <p class="article">&nbsp;</p>
      <i-button type="success" size="large" long @click="curStep=1">同意并继续</i-button>
      <div slot="footer">
        请详细阅读上述条款并点击文档最底部“同意并继续”按钮
        <!-- <i-button type="error" size="large" @click="returnPath">取消</i-button> -->
      </div>
    </div>
    <Form ref="newForm" v-if="curStep===1" :model="guarantorModel"
      :rules="modelValidate"
      label-position="left"
      :label-width="160">
      <Button type="primary" @click="curStep=0">返回上一步</Button>
      <div class="padding-top-10"></div>
      <table class="form-table">
        <thead>
          <tr>
            <th colspan="4" class="table-header">申请单位基本情况</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-row">
            <td width="100%">
              <FormItem label="企业名称" prop="name" class="form-item form-item-50">
                <Input name="name" v-model="guarantorModel.name" placeholder="输入公司名称" />
              </FormItem>
              <Form-item label="成立日期" prop="estDate" class="form-item form-item-50">
                <Date-picker name="estDate" type="date" :value="guarantorModel.estDate" @on-change="changeEstDate" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>
              </Form-item>
            </td>
          </tr>
          <tr class="table-row">
            <td width="100%">
              <FormItem label="社会信用代码" prop="businessLicense" class="form-item form-item-50">
                <Input v-model="guarantorModel.businessLicense" placeholder="输入社会信用代码" />
              </FormItem>
              <FormItem label="类型" prop="type" class="form-item form-item-50">
                <Select v-model="guarantorModel.type" filterable>
                  <Option v-for="(tp,idx) in $common.getEnumSelect($common.guarantorType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                </Select>
              </FormItem>
            </td>
          </tr>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="公司网址" prop="homePage" class="form-item form-item-50">
                <Input v-model="guarantorModel.homePage" placeholder="请输入公司网址">
                </Input>
              </Form-item>
              <Form-item label="电子邮箱" prop="email" class="form-item form-item-50">
                <Input v-model="guarantorModel.email" placeholder="请输入电子邮箱"></Input>
              </Form-item>
            </td>
          </tr>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="注册资本(万元)" prop="capital" class="form-item form-item-50">
                <Input-number :min="0" :step="100" v-model="guarantorModel.capital"></Input-number>
                <Divider type="vertical" v-if="guarantorModel.capital" />
                <h3 style="display:inline-block" v-if="guarantorModel.capital"> {{`¥ ${guarantorModel.capital*10000}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
                <Divider type="vertical" v-if="guarantorModel.capital" />
                <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guarantorModel.capital*10000)}}</h3>
              </Form-item>
              <FormItem label="注册类型" prop="corpType" class="form-item form-item-50">
                <Select v-model="guarantorModel.corpType" filterable>
                  <Option value="有限责任公司">有限责任公司</Option>
                  <Option value="股份有限公司">股份有限公司</Option>
                  <Option value="有限合伙企业">有限合伙企业</Option>
                  <Option value="外商独资公司">外商独资公司</Option>
                  <Option value="个人独资企业">个人独资企业</Option>
                  <Option value="国有独资公司">国有独资公司</Option>
                  <Option value="其他">其他</Option>
                </Select>
              </FormItem>
            </td>
          </tr>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="实缴资本(万元)" prop="capitalPaidIn" class="form-item form-item-50">
                <Input-number :min="0" :step="100" v-model="guarantorModel.capitalPaidIn"></Input-number>
                <Divider type="vertical" v-if="guarantorModel.capitalPaidIn" />
                <h3 style="display:inline-block" v-if="guarantorModel.capitalPaidIn"> {{`¥ ${guarantorModel.capitalPaidIn*10000}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
                <Divider type="vertical" v-if="guarantorModel.capitalPaidIn" />
                <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guarantorModel.capitalPaidIn*10000)}}</h3>
              </Form-item>
              <Form-item label="实缴出资日期" prop="capitalPaidInDate" class="form-item form-item-50">
                <Date-picker type="date" :value="guarantorModel.capitalPaidInDate" @on-change="changeCapitalPaidInDate" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>
              </Form-item>
            </td>
          </tr>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="认缴资本(万元)" prop="capitalSubscribed" class="form-item form-item-50">
                <Input-number :min="0" :step="100" v-model="guarantorModel.capitalSubscribed"></Input-number>
                <Divider type="vertical" v-if="guarantorModel.capitalSubscribed" />
                <h3 style="display:inline-block" v-if="guarantorModel.capitalSubscribed"> {{`¥ ${guarantorModel.capitalSubscribed*10000}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
                <Divider type="vertical" v-if="guarantorModel.capitalSubscribed" />
                <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(guarantorModel.capitalSubscribed*10000)}}</h3>
              </Form-item>
              <Form-item label="认缴出资日期" prop="capitalSubscribedDate" class="form-item form-item-50">
                <Date-picker type="date" :value="guarantorModel.capitalSubscribedDate" @on-change="changeCapitalSubscribedDate" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>
              </Form-item>
            </td>
          </tr>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="经营范围" prop="scope" class="form-item form-item-100">
                <Input v-model="guarantorModel.scope" placeholder="请输入经营范围" type="textarea" :autosize="{minRows: 3,maxRows: 10}"></Input>
              </Form-item>
            </td>
          </tr>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="经营范围" prop="scope" class="form-item form-item-100">
                <Input v-model="guarantorModel.scope" placeholder="请输入经营范围" type="textarea" :autosize="{minRows: 3,maxRows: 10}"></Input>
              </Form-item>
            </td>
          </tr>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="公司电话" prop="tel" class="form-item form-item-50">
                <Input v-model="guarantorModel.tel" placeholder="请输入公司电话">
                </Input>
              </Form-item>
              <Form-item label="住所" prop="address" class="form-item form-item-50">
                <Input v-model="guarantorModel.address" placeholder="请输入公司住所"></Input>
              </Form-item>
            </td>
          </tr>
          <tr class="table-row" v-if="guarantorModel.type===10">
            <td width="100%">
              <Form-item label="偿付充足率" prop="solvency" class="form-item form-item-50">
                <Input v-model="guarantorModel.solvency" placeholder="偿付充足率（保险公司填写）">
                </Input>
              </Form-item>
              <Form-item label="" class="form-item form-item-50">
              </Form-item>
            </td>
          </tr>
          <tr class="table-row" v-else-if="[2,3].indexOf(guarantorModel.type)>-1">
            <td width="100%">
              <Form-item label="资本充足率" prop="solvency" class="form-item form-item-50">
                <Input v-model="guarantorModel.solvency" placeholder="资本充足率（银行业机构填写）">
                </Input>
              </Form-item>
              <Form-item label="" class="form-item form-item-50">
              </Form-item>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="form-table">
        <thead>
          <tr>
            <th colspan="4" class="table-header">法人（负责人）信息</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="姓名" prop="legalPersonName" class="form-item form-item-33">
                <Input v-model="guarantorModel.legalPersonName" placeholder="公司法人姓名"></Input>
              </Form-item>
              <Form-item label="性别" prop="legalPersonGender" class="form-item form-item-33">
                <i-switch v-model="guarantorModel.legalPersonGender" true-color="#2d8cf0" false-color="#ff4949">
                  <span slot="open">男</span>
                  <span slot="close">女</span>
                </i-switch>
              </Form-item>
              <Form-item label="出生年月" prop="legalPersonDOB" class="form-item form-item-33">
                <Date-picker type="date" v-model="guarantorModel.legalPersonDOB" placeholder="YYYY-MM-DD" style="width: 150px"></Date-picker>
              </Form-item>
            </td>
          </tr>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="联系电话" prop="legalPersonTel" class="form-item form-item-33"
                :rules="[{ required: true, message: '请填写', trigger: 'blur' }]">
                <Input v-model="guarantorModel.legalPersonTel" placeholder="法人联系电话"></Input>
              </Form-item>
              <Form-item label="职务" prop="legalPersonRole" class="form-item form-item-33">
                <Input v-model="guarantorModel.legalPersonRole" placeholder="法定代表人职务"></Input>
              </Form-item>
              <Form-item label="政治面貌" prop="legalPersonPolitical" class="form-item form-item-33">
                <Input v-model="guarantorModel.legalPersonPolitical" placeholder="法定代表人政治面貌"></Input>
              </Form-item>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="form-table">
        <thead>
          <tr>
            <th colspan="4" class="table-header">联系人信息</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="姓名" prop="contact" class="form-item form-item-33">
                <Input v-model="guarantorModel.contact" placeholder="联系人姓名"></Input>
              </Form-item>
              <Form-item label="职务" prop="contactRole" class="form-item form-item-33">
                <Input v-model="guarantorModel.contactRole" placeholder="联系人职务"></Input>
              </Form-item>
              <Form-item label="联系电话" prop="contactTel" class="form-item form-item-33"
                :rules="[{ required: true, message: '请填写', trigger: 'blur' }]">
                <Input v-model="guarantorModel.contactTel" placeholder="联系人联系电话"></Input>
              </Form-item>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="form-table">
        <thead>
          <tr>
            <th colspan="4" class="table-header">从业人员信息</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-row">
            <td width="100%">
              <Form-item label="工程建设类专业技术人员人数" prop="qualifiedTotal" class="form-item form-item-33">
                <Input-number :min="0" v-model="guarantorModel.qualifiedTotal" placeholder="工程建设类专业技术人员人数"></Input-number>
              </Form-item>
              <Form-item label="财务人员人数" prop="cpaTotal" class="form-item form-item-33">
                <Input-number :min="0" v-model="guarantorModel.cpaTotal" placeholder="财务人员人数"></Input-number>
              </Form-item>
              <Form-item label="法务人员人数" prop="solicitorTotal" class="form-item form-item-33">
                <Input-number :min="0" v-model="guarantorModel.solicitorTotal" placeholder="法务人员人数"></Input-number>
              </Form-item>
            </td>
          </tr>
        </tbody>
      </table>
    </Form>
    <Form ref="attachmentForm" :model="guarantorModel"
      v-if="guarantorModel.attachments&&curStep===1"
      label-position="left"
      :label-width="200">
      <table class="form-table">
        <thead>
          <tr>
            <th colspan="4" class="table-header">附件上传</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-row" v-if="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_URL')">
            <td width="100%">
              <div class="font-grey">
                <span v-if="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_TEXT')">{{getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_TEXT')}}</span>
                <a :href="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_URL')">点击下载</a>
                <div class="padding-top-20"></div>
              </div>
            </td>
          </tr>
          <tr class="table-row" v-for="(att,idx) in guarantorModel.attachments" :key="idx">
            <td width="100%">
              <FormItem :label="att.name" :prop="`attachments[${idx}].url`"  class="form-item form-item-100"
                :rules="att.required?[{required:true,validator:arrayValidator,trigger:'change'}]:[]">
                <div v-if="att.desc">
                  <p class="font-grey" v-html="att.desc"></p>
                  <a :href="att.template" v-if="att.template" target="_blank">下载模板</a>
                </div>
                <Upload
                  ref="attachmentUploader"
                  :data="OSSParam"
                  :before-upload="handleBeforeUpload"
                  :multiple="true"
                  :max-size="att.fileSizeLimit"
                  :on-success="handleUploadSuccess"
                  :format="getFormats(att.formats)"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleExceededSize"
                  :on-remove="removeItem"
                  :on-preview="previewUploaded"
                  :show-upload-list="false"
                  :action="uploadParams.host">
                  <Poptip trigger="hover" placement="bottom">
                    <Button @click="getOSSParams(idx)"><Icon type="ios-cloud-upload-outline"></Icon>上传附件</Button>
                    <div slot="content">
                      <p class="small font-grey" v-if="att.desc" v-html="att.desc"></p>
                      <span class="small font-grey">格式要求:{{att.formats}}<br>文件大小限制: {{att.fileSizeLimit}}kb<br>文件数量上限: {{att.fileCountLimit}}</span>
                    </div>
                  </Poptip>
                </Upload>
                
                <div class="attachments">
                  <div class="attachment-thumb"
                    @click="previewImgUrl=item;showPreview=true"
                    :key="index"
                    v-for="(item,index) in att.url">
                    <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                    <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                    <div class="attachment-thumb-cover">
                      <Icon type="ios-eye-outline" @click.stop="previewImgUrl=item;showPreview=true"></Icon>
                      <Icon type="ios-trash-outline" @click.stop="removeItem(item, idx)"></Icon>
                    </div>
                    <!-- <template v-if="item.status === 'finished'">
                      <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                      <div class="attachment-thumb-cover">
                        <Icon type="ios-eye-outline" @click="previewImgUrl=item.url;showPreview=true"></Icon>
                        <Icon type="ios-eye-outline" @click="removeItem(item, idx)"></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                    </template> -->
                  </div>
                </div>
              </FormItem>
            </td>
          </tr>
          <tr class="table-row" v-if="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_URL')">
            <td width="100%">
              <div class="font-grey">
                <span v-if="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_TEXT')">{{getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_TEXT')}}</span>
                <a :href="getConfig('GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_URL')">点击下载</a>
                <div class="padding-top-20"></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </Form>
    <Row :gutter="32" v-if="curStep===1">
      <i-col span="12">
        <Button type="primary" size="large" long @click="submit">提交</Button>
      </i-col>
      <i-col span="12" v-if="$common.userType[$store.getters.userInfo.type.toString()] === '保证人'">
        <Button type="warning" size="large" long @click="submitDraft">存草稿</Button>
      </i-col>
    </Row>
    <div v-if="curStep===2">
      <div class="result-page">
        <div class="result-icon success">
          <Icon type="ios-checkmark" color="#fff" size="120" />
        </div>
        <div class="result-title">
          提交成功
        </div>
        <div class="result-message">
          您的入会申请已成功提交，请耐心等待审核，期间请保持手机畅通。
        </div>
        <div class="result-extra">
          如有问题请咨询：0371 - 6917 9969
        </div>
      </div>
    </div>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'guarantor-new',
  components: {
  },
  props: {
  },
  data () {
    return {
      loading: false,
      showGuarantorContract: true,
      addGuarantorAndUser: true,
      curStep: 0,
      guarantorModel: {
        loginName: null,
        password: null,
        rePassword: null,
        passwordMd5: null,
        mobile: null,
        displayName: null,
        roleId: null,
        name: null,
        type: null,
        businessLicense: null,
        legalPersonName: null,
        corpType: null,
        businessTerm: null,
        contact: null,
        contactTel: null,
        contactGender: true,
        contactDept: null,
        contactRole: null,
        regCity: null,
        address: null,
        email: null,
        postCode: null,
        capital: null,
        capitalPaidIn: null,
        capitalPaidInDate: null,
        capitalSubscribed: null,
        capitalSubscribedDate: null,
        estDate: null,
        scope: null,
        homePage: null,
        fax: null,
        tel: null,
        legalPersonID: null,
        legalPersonIDImgs: [],
        legalPersonRole: null,
        legalPersonTitle: null,
        legalPersonTel: null,
        legalPersonGender: true,
        legalPersonPolitical: null,
        legalPersonEduBackground: null,
        legalPersonDOB: null,
        generalManagerName: null,
        generalManagerRole: null,
        generalManagerTitle: null,
        supervisorName: null,
        supervisorTel: null,
        supervisorContactPerson: null,
        supervisorContactTel: null,
        solvency: null,
        totalGuaAmount: null,
        employeeTotal: 0,
        titledTotal: 0,
        titledMedTotal: 0,
        titledSeniorTotal: 0,
        qualifiedTotal: 0,
        regSupervTotal: 0,
        regConstrTotal: 0,
        regCostTotal: 0,
        prjManagerTotal: 0,
        cpaTotal: 0,
        solicitorTotal: 0,
        introduction: null,
        guarRange: null,
        orgChartPath: '',
        attachments: null
      },
      roles: [],
      longTerm: false,
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        businessLicense: [
          { required: true, message: '请填写社会信用代码', trigger: 'blur' }
        ],
        type: [
          { required: true, type: 'number', message: '请填写', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        scope: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        capital: [
          { required: true, type: 'number', message: '请填写', trigger: 'blur' }
        ],
        corpType: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        businessTerm: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        estDate: [
          { required: true, message: '请填写', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请填写公司电话', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请填写业务联系人', trigger: 'blur' }
        ],
        contactTel: [
          { required: true, message: '请填写业务联系电话', trigger: 'blur' }
        ],
        legalPersonName: [
          { required: true, message: '请填写', trigger: 'blur' }
        ]
      },
      cities: [],
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      curOSSParamIndex: 0,
      previewImgUrl: null,
      showPreview: false
    }
  },
  watch: {
    longTerm: function (newVal) {
      if (newVal) {
        this.guarantorModel.businessTerm = '长期'
      } else {
        this.guarantorModel.businessTerm = null
      }
    },
    'guarantorModel.type': function (val) {
      console.log(val)
      this.initAttachment()
    }
  },
  mounted () {
    if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '保证人') {
      this.addGuarantorAndUser = false
    }
    this.initCitySelect()
    this.initAttachment()
    this.initRoles()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async initRoles () {
      let res = await this.$Api.Role.listRoles({
        name: null,
        type: 3,
        isReserved: null
      }, 1, -1).catch(err => {
        console.log(err)
        this.$Message.error(err.message)
      })
      this.roles = res.data
    },
    validateRepassword (rule, value, callback) {
      if (this.guarantorModel.password && value !== this.guarantorModel.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        if (callback) {
          callback()
        }
      }
    },
    async initAttachment () {
      let attaches = await this.getAttachRequirements()
      if (attaches && attaches instanceof Array && attaches.length) {
        this.guarantorModel.attachments = attaches.map(a => {
          a.filePath = null
          a.ossKeys = []
          a.url = []
          return a
        })
      }
    },
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    getAttachRequirements () {
      return this.$store.getters.GUARANTOR_RREGISTER_ATTACHMENT_REQUIREMENTS
    },
    changeBusinessTerm (date) {
      this.guarantorModel.businessTerm = this.$moment(date).format('YYYY-MM-DD')
    },
    changeEstDate (date) {
      this.guarantorModel.estDate = this.$moment(date).format('YYYY-MM-DD')
    },
    changeCapitalPaidInDate (date) {
      this.guarantorModel.capitalPaidInDate = this.$moment(date).format('YYYY-MM-DD')
    },
    changeCapitalSubscribedDate (date) {
      this.guarantorModel.capitalSubscribedDate = this.$moment(date).format('YYYY-MM-DD')
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    getFormats (fmtStr) {
      if (!fmtStr) return null
      let arr = fmtStr.split(',')
      let result = arr.map((a) => {
        return a.trim()
      })
      return result
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.guarantorModel.regCity = val[val.length - 1]
      } else {
        this.guarantorModel.regCity = val
      }
    },
    getOSSParams (index) {
      this.$Api.Guarantor.getUploadParams('profile').then((res) => {
        console.log(res)
        this.uploadParams = {
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index    // 上传控件序号
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    handleBeforeUpload (file) {
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParams[this.curOSSParamIndex] = {
        name: file.name,
        key: filename,
        policy: this.uploadParams.policy,
        OSSAccessKeyId: this.uploadParams.accessid,
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: this.uploadParams.signature,
        fileIndex: this.curOSSParamIndex
      }
      this.OSSParam.name = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
      this.OSSParam.fileIndex = this.curOSSParamIndex
    },
    async handleUploadSuccess (response, file, fileList) {
      let index = this.OSSParams.findIndex(o => o && o.name === file.name)
      let attach = this.guarantorModel.attachments[index]
      if (fileList.length > attach.fileCountLimit) {
        fileList.splice(0, 1)
        this.guarantorModel.attachments[index].ossKeys.splice(0, 1)
      }
      if (!this.guarantorModel.attachments[index].ossKeys) {
        this.guarantorModel.attachments[index].ossKeys = []
      }
      if (!this.guarantorModel.attachments[index].url) {
        this.guarantorModel.attachments[index].url = []
      }
      let ossParam = this.OSSParams[index]
      let filename = 'oss:' + ossParam.key
      file.name = filename
      this.$nextTick(async () => {
        await this.procOssKey(filename).then(url => {
          url.status = 'finished'
          this.guarantorModel.attachments[index].url.push(url)
        })
        this.guarantorModel.attachments[index].ossKeys.push(filename)
        this.guarantorModel.attachments[index].filePath = this.guarantorModel.attachments[index].ossKeys.join(',')
      })
    },
    removeItem (item, attachIdx) {
      let attach = this.guarantorModel.attachments[attachIdx]
      let idx = attach.url.findIndex(o => o.name === item.name)
      attach.url.splice(idx, 1)
      let keys = attach.filePath.split(',')
      keys.splice(idx, 1)
      keys = keys.join(',')
      console.log(keys)
      this.guarantorModel.attachments[attachIdx].ossKeys = keys
      this.guarantorModel.attachments[attachIdx].filePath = keys
    },
    // removeItem (item, fileList) {
    //   let key = item.name.indexOf('oss:') === 0 ? item.name.substr(4) : item.name
    //   let index = this.OSSParams.findIndex(o => o.key === key)
    //   this.guarantorModel.attachments[index].ossKeys = fileList.map((a) => {
    //     return a.name
    //   })
    //   this.guarantorModel.attachments[index].filePath = this.guarantorModel.attachments[index].ossKeys.join(',')
    // },
    previewUploaded (file) {
      let key = file.name.indexOf('oss:') === 0 ? file.name.substr(4) : file.name
      this.procOssKey(key).then((obj) => {
        console.log(obj)
        this.previewImgUrl = obj.url
        this.showPreview = true
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve) => {
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        resolve({
          name: k,
          url,
          type,
          surfix
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '上传文件格式不正确。'
      })
    },
    handleExceededSize () {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '上传文件大小超出限制范围。'
      })
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
    async submit () {
      let formValid = true
      if (this.guarantorModel.businessTerm) {
        this.guarantorModel.businessTerm = require('moment')(this.guarantorModel.businessTerm).format('YYYY-MM-DD')
      }
      await this.$refs.newForm.validate(async (valid) => {
        console.log('valid1', valid)
        if (!valid) {
          formValid = false
        }
      })
      await this.$refs.attachmentForm.validate(async (valid2) => {
        console.log('valid2', valid2)
        if (!valid2) {
          formValid = false
        }
      })
      setTimeout(async () => {
        console.log(formValid)
        if (formValid) {
          console.log(123)
          this.loading = true
          this.$Spin.show()
          let model = JSON.parse(JSON.stringify(this.guarantorModel))
          let payload
          if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '保证人') {
            if (!model.estDate) {
              model.estDate = null
            }
            model.attachments.forEach((att) => {
              if (att.url instanceof Array) {
                att.url = att.url.map((u) => {
                  return u.name.replace('oss:', '')
                }).join(',')
              }
            })
            payload = await Api.Guarantor.submitNewGuarantor(model)
              .catch(err => {
                console.log('err', err)
                this.$Message.error('提交失败!' + err.message)
                this.loading = false
                this.$Spin.hide()
              })
          } else {
            if (!model.attachments) {
              model.attachments = []
            }
            model.attachments.forEach((att) => {
              if (att.url instanceof Array) {
                att.url = att.url.map((u) => {
                  return u.name.replace('oss:', '')
                }).join(',')
              }
            })
            if (this.addGuarantorAndUser) {
              model.passwordMd5 = this.$md5(model.password)
              payload = await Api.Guarantor.addGuarantorAndUser(model)
                .catch(err => {
                  console.log('err', err)
                  this.$Message.error('提交失败!' + err.message)
                  this.loading = false
                  this.$Spin.hide()
                })
            } else {
              payload = await Api.Guarantor.addGuarantor(model)
                .catch(err => {
                  console.log('err', err)
                  this.$Message.error('提交失败!' + err.message)
                  this.loading = false
                  this.$Spin.hide()
                })
            }
          }
          if (payload) {
            console.log('suc', payload)
            this.$Message.success('新增成功!')
            this.guarantorModel = {
              loginName: null,
              password: null,
              rePassword: null,
              passwordMd5: null,
              mobile: null,
              displayName: null,
              roleId: null,
              name: null,
              businessLicense: null,
              legalPersonName: null,
              contact: null,
              contactTel: null,
              regCity: null,
              address: null,
              email: null,
              postCode: null,
              capital: null,
              estDate: null,
              scope: null,
              homePage: null,
              fax: null,
              legalPersonID: null,
              legalPersonIDImgs: [],
              legalPersonRole: null,
              legalPersonTitle: null,
              generalManagerName: null,
              generalManagerRole: null,
              generalManagerTitle: null,
              employeeTotal: 0,
              titledTotal: 0,
              titledMedTotal: 0,
              titledSeniorTotal: 0,
              qualifiedTotal: 0,
              regSupervTotal: 0,
              regConstrTotal: 0,
              regCostTotal: 0,
              prjManagerTotal: 0,
              cpaTotal: 0,
              solicitorTotal: 0,
              introduction: null,
              guarRange: null,
              orgChartPath: '',
              attachments: null
            }
            this.loading = false
            this.$Spin.hide()
            this.curStep = 2
          }
        }
      }, 1000)
    },
    async submitDraft () {
      this.loading = true
      this.$Spin.show()
      let payload
      if (this.guarantorModel.businessTerm) {
        this.guarantorModel.businessTerm = require('moment')(this.guarantorModel.businessTerm).format('YYYY-MM-DD')
      }
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '保证人') {
        let model = JSON.parse(JSON.stringify(this.guarantorModel))
        if (!model.estDate) {
          model.estDate = null
        }
        model.attachments.forEach((att) => {
          if (att.url instanceof Array) {
            att.url = att.url.map((u) => {
              return u.name.replace('oss:', '')
            }).join(',')
          }
        })
        payload = await Api.Guarantor.submitDraft(model)
          .catch(err => {
            console.log('err', err)
            this.$Message.error('提交失败!' + err.message)
            this.loading = false
            this.$Spin.hide()
          })
      }
      if (payload) {
        console.log('suc', payload)
        this.$Message.success('保存成功!')
        this.loading = false
        this.$Spin.hide()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.attachments {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
.attachment-thumb {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-color: #efefef;
  width: 100px;
  height: 100px;
  margin-right: 4px;
  transition: all .2s ease-in-out;
  cursor: pointer;
  padding: 3px;
  border: 1px solid #d2d2d2;
  position: relative;
  &:hover {
    border: 1px solid rgb(65,157,253);
    background-color: #fff;
  }
  overflow: hidden;
  img {
    width: 100%;
  }
  .attachment-thumb-cover{
    opacity: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
    transition: all .3s linear;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  &:hover .attachment-thumb-cover{
    opacity: 1;
  }
  .attachment-thumb-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 5px;
  }
}
.guarantor-contract {
  width: 100%;
  // height: 800px;
  overflow-y: auto;
  background: #fff;
  h1 {
    padding: 10px 0;
  }
  strong {
    font-weight: bold !important;
  }
}
.guarantor-contract u {
  text-decoration: underline;
}
.guarantor-contract .container {
  margin: 0 auto;
  width: 90%;
  position: relative;
}
.guarantor-contract .container h1 {
  font-family: "SimHei", "SimSun";
  font-size: 24px;
  text-align: center;
  margin-top: 2em;
  margin-bottom: 2em;
}
.guarantor-contract .container h3 {
  font-family: "SimHei", "SimSun";
  font-size: 12px;
  text-align: right;
  margin: 0;
  font-weight: 500;
}
.guarantor-contract .container h4 {
  font-family: "SimSun";
  font-size: 16px;
  text-align: left;
  font-weight: 700;
}
.guarantor-contract .container p.article {
  font-family: "SimSun";
  font-size: 14px;
  text-align: left;
  font-weight: 300;
  word-break: normal;
  text-indent: 2em;
  line-height: 2em;
  margin: 0;
}
.guarantor-contract .container p.article.title {
  font-family: "SimHei", "SimSun";
  font-size: 14px;
  text-align: left;
  font-weight: 500;
  word-break: normal;
  text-indent: 2em;
}
.guarantor-contract .container p.article-footer {
  font-family: "SimHei", "SimSun";
  font-size: 14px;
  text-align: right;
  font-weight: 500;
  word-break: normal;
}
.guarantor-contract .container .qrcode {
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
